$(function () {
  $('.faq-sec__qaaBox dl dt').on('click', function () {
    $(this).next().slideToggle();
    $(this).toggleClass('open');
  });

  $('.faq-sec__box__btn').on('click', function () {
    $('.faq-sec__qaaBox dl dd').slideToggle();
    $('.faq-sec__qaaBox dl dt').toggleClass('open');
  });
});
